import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/thumbs-down.vue
var s = {
	name: "DtIconThumbsDown",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--thumbs-down"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Thumbs Down",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M3.25 1.5a.5.5 0 0 0-.48.36l-1.165 4a.5.5 0 0 0 .48.64H5a.5.5 0 0 1 .486.618l-.5 2.06v.002a1.065 1.065 0 0 0 .728 1.275l1.563-3.123A1.503 1.503 0 0 1 8 6.634V1.5H3.25Zm0-1a1.5 1.5 0 0 0-1.44 1.08l-1.165 4a1.5 1.5 0 0 0 1.44 1.92h2.28l-.35 1.44v.001A2.065 2.065 0 0 0 5.993 11.5a.5.5 0 0 0 .453-.276l1.725-3.445v-.002A.5.5 0 0 1 8.62 7.5H10A1.5 1.5 0 0 0 11.5 6V2A1.5 1.5 0 0 0 10 .5H3.25ZM9 1.5v5h1a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5H9Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=thumbs-down.js.map